import { IconButton as MUIIconButtonn } from '@mui/material';


export default function IconButton(props) {
    const { Icon, size='small', color, onClick, iconStyleSX,iconObjProps,...rest   } = props;
   
    return (
        <MUIIconButtonn
            
            size={size || "large"}
            color={color || "primary"}
            onClick={onClick}
            {...rest}
        >
           <Icon {...iconObjProps} sx={{...iconStyleSX}} />
        </MUIIconButtonn>
    )
}
